export const bottomToTop = {
    from: { y: 50 },
    to: { y: 0 },
};